<template>
<div>
  <header-component></header-component>
  <div class="container-fluid mt--6">
    <div class="card">
      <div class="card-header">
        <h3 
          class="mb-0" 
          style="text-transform:capitalize;">Attributes List</h3>
        <div class="col-lg-12 col-5 text-right">
          <base-button 
            size="sm" 
            type="primary" 
            @click="createAttribute">Add New</base-button>
        </div>
      </div>
       <el-table
        class="table-responsive table-flush"
        header-row-class-name="thead-light"
        :data="attributes"
      >
        <el-table-column label="Attribute Name" min-width="170px" prop="label" sortable></el-table-column>
        <el-table-column min-width="70px">
          <template slot-scope="scope">
            <el-dropdown slot="dropdown" @command="command => handleAction(scope.row, command)">
             <el-button type="primary" size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
              <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                <el-dropdown-item command="edit">Edit</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog 
      :visible.sync="addAttribute" 
      title="Add Attribute" 
    >
      <add-attribute @close="addAttribute = false"></add-attribute>
    </el-dialog>
  </div>
  </div>
</template>
<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button
} from "element-ui";
import AddAttribute from "./AddAttributes";
import { mapGetters, mapActions,mapMutations } from "vuex";
import headerComponent from "../Components/HeaderComponent";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    "add-attribute": AddAttribute,
    "header-component": headerComponent,
    [Button.name] : Button
  },
  data: () => {
    return {
      addAttribute: false
    };
  },

  computed: {
    ...mapGetters({
      attributes: "attribute/getAttributes",
      attribute:"attribute/getAttribute"
    })
  },

  mounted() {
    this.getAttributes();
  },

  methods: {
    ...mapActions({getAttributes : 'attribute/getAttributes',  fetchAttribute:'attribute/fetchAttribute'}),
   ...mapMutations({setAttribute : 'attribute/setAttribute', resetAttribute: 'attribute/resetAttribute'}),
   handleAction(attribute, command) {
      if (command === "edit") {
         this.fetchAttribute(attribute.attributeId).then((res) => {
           this.addAttribute = true;
           this.setAttribute(res);
         })
       // this.$router.push('/attributes/add/'+attribute.attributeId);
      }
    },
    createAttribute() {
      this.resetAttribute();
      this.addAttribute = true;
    }
  }
};
</script>